module.exports = __webpack_public_path__ + "static/media/desktopMainImage@2x.902058f0.png";